/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Package_Count_HintInputs */

const vi_carrier_form_package_count_hint = /** @type {(inputs: Carrier_Form_Package_Count_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số thùng gửi đi. Hãng in số này lên vận đơn và kiểm đếm theo nó; nhãn thùng in mỗi kiện một tờ.`)
};

/**

* @param {Carrier_Form_Package_Count_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_package_count_hint = /** @type {((inputs?: Carrier_Form_Package_Count_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Package_Count_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_package_count_hint(inputs)
});